export default __webpack_public_path__ + "static/media/Dashboard-w.606e1b82.svg";